// extracted by mini-css-extract-plugin
export var leftAlign = "_10-2";
export var popper = "_10-0";
export var subtitle = "_10-1";